export default __webpack_public_path__ + "static/media/ziggle_zaggle_wiggle_waggle.eed822b6.svg";